import { Typography } from "mobily-ui-library";
import { useTranslation } from "react-i18next";
import './MapPopup.scss';

function MapNotiyPopup(props: any) {
    const { t } = useTranslation();

    return (
        <div className="notifyPopup">
            <>
                {props.outOfDelivery ? (
                    <div className="outOfDelivery">
                        <Typography className="outOfDeliveryTitle">{t('out_of_delivery')}</Typography>
                        <Typography className="outOfDeliveryText">{t('select_an_address')}</Typography>
                    </div>
                ) : (
                    <div className="location">
                        <Typography className="locationTitle">{t('pinned_location')}</Typography>
                        <Typography className="locationAddress">{props.address}</Typography>
                    </div>
                )}
            </>
        </div>
    )
}

export default MapNotiyPopup;